import { useContext } from "react";

import HeaderIcon from "../../assets/icons/header-icon.svg";

import { ContractContext } from "../../context/contract";

import "./styles.scss";

const Header = (): JSX.Element => {
  const { headerData } = useContext(ContractContext);
  const { contractStatus, createdAt } = headerData;

  return (
    <div className="header-container">
      <img src={HeaderIcon} alt="" />
      <div className="heading">
        <div className="heading-title">Digital Contracts</div>
        <div className="heading-date-status">
          {createdAt && (
            <span className="heading-date">Created at: {createdAt}</span>
          )}
          {contractStatus && (
            <span className={`heading-status ${contractStatus}`}>
              {contractStatus}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
